import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "ant-design:apple-filled" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M17.8237 12.5555C17.8142 10.957 18.5452 9.75234 20.0212 8.86406C19.1957 7.69219 17.9467 7.04766 16.3003 6.92344C14.7415 6.80156 13.036 7.82344 12.4115 7.82344C11.7516 7.82344 10.2424 6.96562 9.05497 6.96562C6.60436 7.00312 4 8.90156 4 12.7641C4 13.9055 4.21053 15.0844 4.63158 16.2984C5.19455 17.8969 7.22411 21.8133 9.34119 21.75C10.4482 21.7242 11.2312 20.9719 12.6717 20.9719C14.0697 20.9719 14.7936 21.75 16.0283 21.75C18.1643 21.7195 19.9999 18.1594 20.5345 16.5562C17.6699 15.218 17.8237 12.6375 17.8237 12.5555ZM15.3376 5.40703C16.5369 3.99609 16.4281 2.71172 16.3926 2.25C15.3329 2.31094 14.1076 2.96484 13.4098 3.76875C12.641 4.63125 12.1892 5.69766 12.2862 6.9C13.4311 6.98672 14.4766 6.40312 15.3376 5.40703Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }